import {useState} from 'react'
import {useSignup} from "../hooks/useSignup"
import {useParams } from "react-router-dom"


const Signup = () => {

    const [email,setEmail] = useState('')
    const [name, setName] = useState('')
    const [surname, setSurname] = useState('')
    const [nationalID, setNationalID] = useState('')
    const [tuckshopname, setTuckshopname] = useState('')
    const [password, setPassword] = useState('')
    const [location, setLocation] = useState('')
    const [contacts, setContacts] = useState('')
    const [balance, setBalance] = useState('')
    const [description, setDescription] = useState('')
    const {signup, error, isLoading} =useSignup()
    const cos = useParams()
    const stringified = JSON.stringify(cos)
    const referall = stringified.substr(6,24)
    

    const handleSubmit = async (e) => {
        e.preventDefault()
        setBalance("0")
        await signup(email,name,surname,nationalID,tuckshopname,location,contacts,description,referall,balance,password)
    }

    return (
        <form className="signup" onSubmit={handleSubmit}>
         <h3>Sign up</h3>

         <label> Email:</label>
         <input
         type="email"
         onChange={(e) => setEmail(e.target.value)}
         value={email}
         />   
        
        <label> Name:</label>
         <input
         type="String"
         onChange={(e) => setName(e.target.value)}
         value={name}
         />  

         <label> Surname:</label>
         <input
         type="String"
         onChange={(e) => setSurname(e.target.value)}
         value={surname}
         />  

        <label> nationalID:</label>
         <input
         type="String"
         onChange={(e) => setNationalID(e.target.value)}
         value={nationalID}
         />  

         <label> Tuckshop Name:</label>
         <input
         type="String"
         onChange={(e) => setTuckshopname(e.target.value)}
         value={tuckshopname}
         />  

        <label> Location:</label>
         <input
         type="String"
         onChange={(e) => setLocation(e.target.value)}
         value={location}
         />

        <label> Contacts:</label>
         <input
         type="String"
         onChange={(e) => setContacts(e.target.value)}
         value={contacts}
         />

        <label> Description:</label>
         <input
         type="String"
         onChange={(e) => setDescription(e.target.value)}
         value={description}
         />

         <label> Referee:{referall}</label>
         <input
         type="String"
         value={referall}
         /> 

         <label> Password:</label>
         <input
         type="password"
         onChange={(e) => setPassword(e.target.value)}
         value={password}
         /> 

        <button disabled={isLoading}> Sign up</button>
        {error && <div className="error">{error}</div>}

        </form>
    )
}

export default Signup